<template>
  <div class="template-wrapper">
    <div class="fixed-header">
      <div class="header-text-wrapp">
        <BlockHeader name="PROJECT DETAILS" lg="12" />
      </div>
      <HistoryModal :project="project" />
      <div class="header-button-wrapp">
        <span v-if="isConnected" style="margin-right: 9px">
          <div class="small-loader-box" v-if="compliting">
            {{ 'saving_message' | i18n }}
            <div class="small-loader">
              <Loader />
            </div>
          </div>
          <span v-else>
            <span v-if="colomns.project !== 12">
              <span style="margin-left: 10px">
                <b-button size="sm" variant="primary" :disabled="colomns.video <= 4" @click="() => zoomProject(1)">
                  <BIconCaretLeftFill />
                </b-button>
              </span>
              <span style="margin-left: 10px">
                <b-button size="sm" variant="primary" :disabled="colomns.project <= 5" @click="() => zoomProject(-1)">
                  <BIconCaretRightFill />
                </b-button>
              </span>
            </span>
            <b-button
              v-if="project.status !== PROJECT_STATUSES.FINISHED"
              style="margin-left: 10px"
              size="sm"
              variant="primary"
              @click="() => completeProject({ silent: true })"
            >
              {{ 'Save' | i18n }}
            </b-button>
            <b-button
              v-if="project.status !== PROJECT_STATUSES.FINISHED"
              style="margin-left: 10px"
              size="sm"
              variant="primary"
              v-b-modal.saveAndSubmitModal
            >
              {{ 'save_submit' | i18n }}
            </b-button>
            <SubmitModal id="saveAndSubmitModal" :completeProject="completeProject" />
          </span>
        </span>
        <span v-if="colomns.project === 12">
          <b-button size="sm" variant="outline-primary" @click="() => triggerWindow('video', 12)">{{ 'Close' | i18n }}</b-button>
        </span>
      </div>
    </div>
    <div class="inputs-block" v-if="loaded">
      <div class="history-block">
        <div class="d-flex flex-column w-50">
          <Checkbox
            v-model="translateProject"
            placeholder="Translate project"
            :left="0"
            :bottom="5"
            form-group-id="translate_project"
            :input="onChangeTranslateProject"
          />
          <Select
            v-if="translateProject"
            v-model="language"
            :options="languagesOptions"
            :on-change="() => generateTemplate(false)"
            form-group-id="Language"
            placeholder="Language"
            input-placeholder="Select language"
            class="mb-0"
          />
        </div>
        <div>
          <b-button v-if="history.length" size="sm" variant="outline-primary" @click="showHistory" style="margin-top: 3px">
            {{ 'History' | i18n }}
          </b-button>
        </div>
      </div>
      <Group
        v-for="group in selectedTemplate.groups"
        :key="group.id"
        :group="group"
        :setFieldValue="setFieldValue"
        :setFieldTextInputValue="setFieldTextInputValue"
        :fieldsValue="fieldsValue"
        :fieldsTextInputValue="fieldsTextInputValue"
        :getFile="getFile"
        :getFileURL="getFileURL"
        :confirmationValues="confirmationValues"
        :excludeFromPDFValues="excludeFromPDFValues"
        :enableConfirmation="true"
        :hasAccessToProject="hasAccessToProject"
        :hasAccessToExternal="hasAccessToExternal"
        :setConfirmationValue="setConfirmationValue"
        :setExcludeFromPDFValue="setExcludeFromPDFValue"
        :feeds="feeds"
        :translateLanguage="language"
        :enableTranslation="translateProject"
        :showValidation="true"
        :setScreenshotData="setScreenshotData"
        groupName="Topic"
        :isSignatureDisable="isSignatureDisable"
        :viewMode="project.status === PROJECT_STATUSES.FINISHED"
      />
      <EditScreenshot
        id="send-screenshot-to-file-field"
        :title="'Edit screenshot' | i18n"
        :screenshot="screenshot"
        :hash="project.hash"
        :setFieldValue="setFieldValue"
        :screenshotField="screenshotField"
      />
    </div>
    <div v-if="!loaded || !isConnected" class="project-loader">
      <div>
        {{ 'Synchronizing Project information' | i18n }}
      </div>
      <Loader />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

import api from '../../../../../api';
import { BIconCaretRightFill, BIconCaretLeftFill } from 'bootstrap-vue';

import BlockHeader from '../../../../common/block-header';
import Group from '../../../../reports/cases/components/group';
import Loader from '../../../../common/loader';
import Checkbox from '../../../../common/checkbox';
import Select from '../../../../common/select';
import HistoryModal from './history-modal';
import SubmitModal from './submit-modal';
import EditScreenshot from './modals/edit-screenshot';

import { ReportsMixin, NotificationMixin, AuthStorageMixin, AuthMixin, ProjectsMixin } from '../../../../../../mixins';
import { ENTRY_TYPES, VALIDATION_RULES, WS_TYPES, ENTRY_TYPES_FILES, ENTRY_TYPES_DRAW, PROJECT_STATUSES } from '../../../../../../../../../constants';
import { isSignatureDisableFunction } from '../../milestone/helpers';

let timeInterval = null;
let uploadingTimeout = null;
let requestedConnection = false;

export default {
  name: 'Project',
  components: {
    BlockHeader,
    Group,
    Loader,
    BIconCaretRightFill,
    BIconCaretLeftFill,
    HistoryModal,
    Checkbox,
    Select,
    SubmitModal,
    EditScreenshot,
  },
  mixins: [ProjectsMixin, NotificationMixin, AuthMixin, AuthStorageMixin, ReportsMixin],
  props: {
    zoomProject: {
      type: Function,
      default: () => {},
    },
    meetingId: {
      type: String,
      default: null,
    },
    triggerWindow: {
      type: Function,
      default: () => {},
    },
    project: {
      type: Object,
      default: () => {},
    },
    languages: {
      type: Array,
      default: () => {},
    },
    colomns: {
      type: Object,
      default: () => {},
    },
    connection: {
      type: WebSocket,
      default: () => {},
    },
    isConnected: {
      type: Boolean,
    },
    setConnection: {
      type: Function,
      default: () => {},
    },
    setIsConnected: {
      type: Function,
      default: () => {},
    },
    requestAuthUsers: {
      type: Object,
      default: () => {},
    },
    requestAuthUsersLoading: {
      type: Object,
      default: () => {},
    },
    setRequestAuthUsers: {
      type: Function,
      default: () => {},
    },
    setRequestAuthUsersLoading: {
      type: Function,
      default: () => {},
    },
    setMeetingHash: {
      type: Function,
      default: () => {},
    },
    setWaitingForAccess: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      compliting: false,
      translateProject: false,
      selectedTemplate: {},
      fieldsValue: {},
      fieldsTextInputValue: {},
      confirmationValues: {},
      excludeFromPDFValues: {},
      feeds: {},
      loaded: false,
      history: [],
      language: '',
      screenshot: null,
      screenshotField: {},
      PROJECT_STATUSES,
      aliveId: null,
    };
  },
  computed: {
    hasAccessToProject: function () {
      const u = this.project.remoteSupport.find((m) => m.id == this.auth.id);
      return Boolean(u);
    },
    hasAccessToExternal: function () {
      const u = this.project.onSiteSupport.find((m) => m.id == this.auth.id);
      return Boolean(u);
    },
    languagesOptions: function () {
      return this.languages.map((l) => ({ value: l.value, text: l.name }));
    },
    isSignatureDisable: function () {
      return isSignatureDisableFunction({
        selectedTemplate: this.selectedTemplate,
        confirmationValues: this.confirmationValues,
        fieldsValue: this.fieldsValue,
      });
    },
  },
  async created() {
    if (!this.meetingId) {
      const history = await api.projectMilestones.getHistoryById(this.project.id);
      this.history = history.data;

      await this.setDefaultLanguage();

      await this.generateTemplate(true);

      this.updateConfirmation();
    }
  },
  async destroyed() {
    if (timeInterval) {
      clearInterval(timeInterval);
    }
  },
  async mounted() {
    setTimeout(() => {
      this.connectToLive();
    }, 2000);
  },
  methods: {
    async setDefaultLanguage() {
      this.language = null;

      try {
        const auth = localStorage.getItem('auth');
        const lng = localStorage.getItem('lng');

        if (lng) {
          const str = JSON.parse(lng);
          this.language = str.toUpperCase();
        }

        if (auth) {
          const json = JSON.parse(auth);
          if (json.language) {
            this.language = json.language.toUpperCase();
          }
        }
      } catch (e) {
        this.language = null;
      }
    },
    async onChangeTranslateProject() {
      await this.setDefaultLanguage();
      await this.generateTemplate(false);
    },
    async generateTemplate(initial) {
      const template = this.project.template;

      const groups = [];
      const groupsFields = {};

      const translation = template.translation;

      for (const currentField of template.fields) {
        if (currentField.showTextInput) {
          Vue.set(this.fieldsTextInputValue, currentField.key, currentField.textInputValue);
          Vue.set(this.fieldsTextInputValue, currentField.id, currentField.textInputValue);
        }

        if (currentField.entryType === ENTRY_TYPES.FEED) {
          this.$set(this.feeds, this.project.fields[currentField.key], []);
        }

        if (!groupsFields[currentField.groupId]) {
          groupsFields[currentField.groupId] = [];
        }
        currentField.required = currentField.rules.some((r) => r.name === VALIDATION_RULES.REQUIRED);

        const isTranslatedTitle = translation[currentField.key] && translation[currentField.key][this.language];

        const temporaryTitle = this.translateProject && !isTranslatedTitle ? await this.getTranslation(currentField.title) : currentField.title;
        const title = isTranslatedTitle ? translation[currentField.key][this.language] : temporaryTitle;

        const description =
          isTranslatedTitle || this.translateProject ? await this.getTranslation(currentField.description) : currentField.description;

        const mappedValues = [];
        if (currentField.mappedValues.length && this.translateProject) {
          for (const mappedValue of currentField.mappedValues) {
            const translatedValue = await this.getTranslation(mappedValue.value);
            const newMappedValue = translatedValue && translatedValue.data ? { ...mappedValue, value: translatedValue.data } : mappedValue;
            mappedValues.push(newMappedValue);
          }
        }

        groupsFields[currentField.groupId].push({
          ...currentField,
          mappedValues: mappedValues.length ? mappedValues : currentField.mappedValues,
          title: title.data || title,
          description: (description ? description.data : '') || description,
        });
      }

      for (const currentGroup of template.groups) {
        const isTranslatedName = translation[currentGroup.id] && translation[currentGroup.id][this.language];
        const temporaryName = this.translateProject && !isTranslatedName ? await this.getTranslation(currentGroup.name) : currentGroup.name;
        const name = isTranslatedName ? translation[currentGroup.id][this.language] : temporaryName;

        const data = {
          name: name.data || name,
          id: currentGroup.id,
          isConfirmation: currentGroup.isConfirmation,
          isFile: currentGroup.isFile,
          file: currentGroup.file,
          fields: groupsFields[currentGroup.id],
        };
        groups.push(data);

        const groupId = currentGroup.id;
        const newValueExcludeFromPDF = this.project.excludeFromPDF[groupId] || this.excludeFromPDFValues[groupId] || false;
        this.$set(this.excludeFromPDFValues, currentGroup.id, newValueExcludeFromPDF);
      }

      if (initial) {
        this.fieldsValue = {
          ...this.project.fields,
          ...this.project.report.fields,
        };
      }

      this.selectedTemplate = {
        name: template.name,
        id: template.id,
        groups,
      };
    },
    async getTranslation(message) {
      try {
        if (!message) {
          return '';
        }
        return await api.translate.translate({
          message,
          language: this.language,
        });
      } catch (e) {
        console.log(e, 'Translation error');
      }
    },
    showHistory() {
      this.$root.$emit('bv::show::modal', 'history-modal');
    },
    async connectToLive() {
      const auth = this.authStorageService.getAuth() || {};

      const base = axios.defaults.baseURL.replace('http://', '').replace('https://', '');
      const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
      const connection = new WebSocket(`${wsProtocol}://${base}/live?token=${auth.access_token}`);
      this.setConnection(connection);
      connection.onopen = () => {
        this.setIsConnected(true);
        this.showNotification({ type: 'success', message: this.$translate('Connected to real time server') });

        if (this.aliveId) {
          clearInterval(this.aliveId);
        }

        const alive = () =>
          connection.send(
            JSON.stringify({
              type: WS_TYPES.PROJECT_USER_ALIVE,
              id: this.project.id,
              rootProject: this.project.project,
            })
          );
        this.aliveId = setInterval(alive, 30000);
        alive();

        if (this.meetingId && !requestedConnection) {
          requestedConnection = true;
          connection.send(
            JSON.stringify({
              type: WS_TYPES.REQUEST_MEETING_HASH,
              id: this.meetingId,
            })
          );
        }
      };
      connection.onerror = (error) => {
        console.log(error, 'error');
      };
      connection.onclose = (m) => {
        this.setIsConnected(false);
        if (this.aliveId) {
          clearInterval(this.aliveId);
        }
        setTimeout(() => {
          this.connectToLive();
        }, 5000);
      };

      connection.onmessage = (message) => {
        try {
          const data = JSON.parse(message.data);
          console.log(data, 'data');
          if (data && data.type === WS_TYPES.MEETING_HASH) {
            this.setWaitingForAccess(false);
            this.setMeetingHash(data.value);
          }
          if (data && data.type === WS_TYPES.WAITING_ACCESS) {
            this.setWaitingForAccess(true);
          }
          if (data && data.type === WS_TYPES.DECLINE_AUTHORIZATION) {
            this.$router.go(-1);
          }
          if (data && data.type === WS_TYPES.PROJECT && data.id === this.project.id) {
            this.fieldsValue[data.key] = data.value;
          }
          if (data && data.type === WS_TYPES.PROJECT_TEXT_INPUT && data.id === this.project.id) {
            this.fieldsTextInputValue[data.key] = data.value;
          }
          if (data && data.type === WS_TYPES.PROJECT_CONFIRMATION && data.id === this.project.id) {
            this.confirmationValues[data.key] = data.value;
          }
          if (data && data.type === WS_TYPES.PROJECT_EXCLUDE_FROM_PDF && data.id === this.project.id) {
            this.excludeFromPDFValues[data.key] = data.value;
          }
          if (data && data.type === WS_TYPES.REQUEST_AUTHORIZATION && (data.projectId === this.project.id || data.meetingId === this.meetingId)) {
            this.setRequestAuthUsers({
              [data.email]: {
                email: data.email,
              },
              ...this.requestAuthUsers,
            });
          }
          if (data && data.type === WS_TYPES.HIDE_AUTHORIZATION && (data.projectId === this.project.id || data.meetingId === this.meetingId)) {
            const newObj = { ...this.requestAuthUsers };
            delete newObj[data.email];
            this.setRequestAuthUsers(newObj);
            const newLoading = { ...this.requestAuthUsersLoading };
            newLoading[data.email] = false;
            this.setRequestAuthUsersLoading(newLoading);
          }
          if (data && data.type === WS_TYPES.PROJECT_FEED && this.feeds[data.id]) {
            this.feeds[data.id] = data.messages;
          }
        } catch (e) {
          console.log(e, 'e');
        }
      };
    },
    async setConfirmationValue(key, v) {
      if (this.isConnected && this.project.status !== PROJECT_STATUSES.FINISHED) {
        this.connection.send(
          JSON.stringify({
            type: WS_TYPES.PROJECT_CONFIRMATION,
            id: this.project.id,
            key: key,
            value: v,
          })
        );
      }
    },
    async setExcludeFromPDFValue(key, v) {
      if (this.isConnected && this.project.status !== PROJECT_STATUSES.FINISHED) {
        this.connection.send(
          JSON.stringify({
            type: WS_TYPES.PROJECT_EXCLUDE_FROM_PDF,
            id: this.project.id,
            key: key,
            value: v,
          })
        );
      }
    },
    async updateConfirmation() {
      const { confirmation } = await api.projectMilestones.getConfirm(this.project.id);
      const d = {
        onSiteSupport: false,
        remoteSupport: false,
      };
      this.project.template.groups.forEach((g) => {
        if (!confirmation[g.id]) {
          this.$set(this.confirmationValues, g.id, d);
        } else {
          this.$set(this.confirmationValues, g.id, confirmation[g.id]);
        }

        this.project.template.fields.forEach((field) => {
          if (!confirmation[field.key]) {
            this.$set(this.confirmationValues, field.key, d);
          } else {
            this.$set(this.confirmationValues, field.key, confirmation[field.key]);
          }
        });
      });
      this.loaded = true;
    },
    async completeProject({
      silent,
      translateLanguage,
      firstChatTranslateLanguage,
      secondChatTranslateLanguage,
      isTranslatedChatContent,
      isReportWithTranslation,
      complete,
    }) {
      try {
        this.compliting = true;

        await api.projectMilestones.submit({}, this.project.id, {
          silent,
          translateLanguage,
          firstChatTranslateLanguage,
          secondChatTranslateLanguage,
          complete,
          isTranslatedChatContent,
          isReportWithTranslation,
        });

        const history = await api.projectMilestones.getHistoryById(this.project.id);
        this.history = history.data;
        this.showNotification({ type: 'success', message: this.$translate('submitted_successfully') });
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      } finally {
        this.compliting = false;
      }
    },
    mapMilestonePayload(params) {
      const payload = new FormData();

      params.fields.forEach((field) => {
        payload.append(`field_${field.key}`, this.reportsService.mapFieldValue(field));
        if (field.showTextInput) {
          payload.append(`field_${field.key}_textInputValue`, typeof field.textInputValue !== 'undefined' ? field.textInputValue : null);
        }
      });

      return payload;
    },
    async setFieldTextInputValue(field, value) {
      if (this.isConnected && this.project.status !== PROJECT_STATUSES.FINISHED) {
        this.fieldsTextInputValue[field.id] = value;
        this.fieldsTextInputValue[field.key] = value;

        this.connection.send(
          JSON.stringify({
            type: WS_TYPES.PROJECT_TEXT_INPUT,
            id: this.project.id,
            key: field.key,
            value,
          })
        );
      }
    },
    async setFieldValue(field, value) {
      const isFile = ENTRY_TYPES_FILES.includes(field.entryType);
      const isDrawField = ENTRY_TYPES_DRAW.includes(field.entryType);

      if (this.isConnected && this.project.status !== PROJECT_STATUSES.FINISHED) {
        if (isFile) {
          if (!isDrawField || (isDrawField && !value)) {
            Vue.set(this.fieldsValue, field.id, value);
            Vue.set(this.fieldsValue, field.key, value);
          } else {
            Vue.set(this.fieldsValue, field.id, value);
          }

          try {
            this.compliting = true;
            const fields = this.mapMilestonePayload({
              fields: [
                {
                  ...field,
                  value,
                },
              ],
            });

            await api.projectMilestones.updateFields(fields, this.project.id);
          } catch (err) {
            this.showNotification({ type: 'error', message: err.message });
          } finally {
            if (uploadingTimeout) {
              clearTimeout(uploadingTimeout);
            }
            uploadingTimeout = setTimeout(() => {
              this.compliting = false;
            }, 2000);
          }
        } else {
          Vue.set(this.fieldsValue, field.id, value);
          Vue.set(this.fieldsValue, field.key, value);

          this.connection.send(
            JSON.stringify({
              type: WS_TYPES.PROJECT,
              id: this.project.id,
              key: field.key,
              value: this.reportsService.mapFieldValue({
                value,
                ...field,
              }),
            })
          );
        }
      }
    },
    getFile(id) {
      return window.open(this.getFileURL(id), '_blank');
    },
    getFileURL(id) {
      const auth = this.authStorageService.getAuth();
      return `${axios.defaults.baseURL}/api/v1/one/project-milestone/${this.project.id}/file/${id}?authorization=${auth.access_token_link}`;
    },
    setScreenshotData({ screenshot, field }) {
      this.screenshot = screenshot;
      this.screenshotField = field;
    },
  },
};
</script>

<style scoped lang="scss">
.inputs-block {
  padding: 70px 15px 0 15px;
  height: 100vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.template-wrapper {
  border-left: 1px solid #e8e7e7;
  height: 100vh;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
}

.fixed-header {
  top: 0;
  left: 0;
  background: white;
  padding: 15px;
  position: absolute;
  width: 100%;
  z-index: 1000;
  border-bottom: 1px solid #d9d9d9;
}

.fixed-header .block-header {
  margin: 0;
}

.header-button-wrapp {
  // position: absolute;
  // top: 0;
  // right: 5px;
  height: 100%;
  display: flex;
  align-content: center;
  align-items: center;
}

.small-loader {
  height: 35px;
  transform: scale(0.3);
  margin-top: -54px;
  margin-left: 15px;
}
.small-loader-box {
  height: 50px;
  display: flex;
  // flex-direction: column;
  align-items: center;
  color: #dc3545;
}

.project-loader {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  text-align: center;
  font-size: 20px;
  position: absolute;
  z-index: 9;
  width: 100%;
  background: white;
}

.header-text-wrapp {
  width: 50%;
}

.history-block {
  margin-bottom: 20px;
  position: relative;
  right: 0px;
  display: flex;
  justify-content: space-between;
  margin-left: 16px;
}

.translation-block {
  display: flex;
}
</style>
